import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.apply_flexi_loan.newDocUploads.bankStatements.title',
        defaultMessage: '{strongText} for the last {duration}'
    },
    subtitle: {
        id: '_.apply_flexi_loan.newDocUploads.bankStatements.subtitle',
        defaultMessage: 'How would you like to share these?'
    },
    manualUploadTitle: {
        id: '_.apply_flexi_loan.newDocUploads.BankStatements.manualUpload.manualUploadTitle',
        defaultMessage: 'Upload statements manually'
    },
    firstBullet: {
        id: '_.apply_flexi_loan.newDocUploads.BankStatements.manualUpload.first_bullet',
        defaultMessage: 'We accept PDF statements.'
    },
    secondBullet: {
        id: '_.apply_flexi_loan.newDocUploads.BankStatements.manualUpload.second_bullet',
        defaultMessage:
            'Your transactions must cover the stated period and be from the accounts(s) where the majority of your business revenue is generated'
    }
});
